import Vue from 'vue'
import Vuex from 'vuex'
// import { APPID } from '../config/index'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: localStorage.getItem('sdInfo'),
    shareInfo: localStorage.getItem('shareInfo'),
    globalLoading: false
  },
  mutations: {
    clearInfo(state) {
      state.userInfo = null
      localStorage.removeItem('sdInfo')
      const src = encodeURIComponent(process.env.VUE_APP_REDIRECT_URI)
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_APPID}&redirect_uri=${src}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
      window.location.href = url
    },
    setUserInfo(state, userInfo) {
      state.userInfo = JSON.stringify(userInfo)
      localStorage.setItem('sdInfo', JSON.stringify(userInfo))
    },
    setShareInfo(state, shareInfo) {
      state.shareInfo = JSON.stringify(shareInfo)
      localStorage.setItem('shareInfo', JSON.stringify(shareInfo))
    },
    setGlobalLoading(state, loading) {
      state.globalLoading = loading
    }
  },
  actions: {
    logout({ commit }) {
      commit('clearInfo')
    }
  },
  getters: {
    userInfo: state => {
      return JSON.parse(state.userInfo)
    },
    shareInfo: state => {
      return JSON.parse(state.shareInfo)
    },
    globalLoading: state => state.globalLoading
  }
})
